// services/PromocionesService.js - Versión mejorada con soporte para productos guardados
class PromocionesService {
  /**
   * Calcula las promociones aplicables a un pedido
   * @param {Array} pedido - Array de productos en el pedido (incluye nuevos y guardados)
   * @param {Array} promocionesDisponibles - Promociones disponibles
   * @returns {Array} - Promociones aplicadas
   */
  static async calcularPromociones(pedido, promocionesDisponibles) {
    console.log('🔥 INICIANDO CÁLCULO DE PROMOCIONES');
    console.log('🔥 Pedido recibido:', pedido);
    console.log('🔥 Promociones disponibles:', promocionesDisponibles);
    
    if (!pedido || pedido.length === 0 || !promocionesDisponibles || promocionesDisponibles.length === 0) {
      console.log('🔥 No hay pedido o promociones disponibles, retornando array vacío');
      return [];
    }

    const promocionesAplicadas = [];

    // Primero aplicar promociones tipo 1 (descuento directo en producto)
    this.aplicarPromocionesT1(pedido, promocionesDisponibles, promocionesAplicadas);

    // Luego aplicar promociones tipo 2 (2x1, nxm, etc.)
    this.aplicarPromocionesT2(pedido, promocionesDisponibles, promocionesAplicadas);

    // Finalmente aplicar promociones tipo 3 (combos, más complejas)
    await this.aplicarPromocionesT3(pedido, promocionesDisponibles, promocionesAplicadas);

    console.log('🔥 PROMOCIONES APLICADAS FINAL:', promocionesAplicadas);
    return promocionesAplicadas;
  }

  /**
   * Aplicar promociones tipo 1 (descuento porcentual)
   * @param {Array} pedido - Productos en el pedido (nuevos y guardados)
   * @param {Array} promocionesDisponibles - Promociones disponibles
   * @param {Array} promocionesAplicadas - Array donde se agregarán las promociones aplicadas
   */
  static aplicarPromocionesT1(pedido, promocionesDisponibles, promocionesAplicadas) {
    // Filtrar promociones tipo 1 activas
    const promocionesT1 = promocionesDisponibles.filter(p =>
      (p.tipo === '1' || p.tipo === 1) && p.activa !== false
    );

    if (promocionesT1.length === 0) return;

    // Aplicar a cada producto
    pedido.forEach(producto => {
      // Buscar promociones aplicables al producto
      const promocionesAplicables = promocionesT1.filter(promo => {
        const idProducto = parseInt(producto.idProducto || producto.idPlatillo);
        return promo.aplicaProductos && promo.aplicaProductos.includes(idProducto);
      });

      // Si hay promociones, aplicar la de mayor descuento
      if (promocionesAplicables.length > 0) {
        // Ordenar por porcentaje de descuento (mayor primero)
        const promocionMayor = promocionesAplicables.sort((a, b) => {
          const descuentoA = parseFloat(a.descuento || 0);
          const descuentoB = parseFloat(b.descuento || 0);
          return descuentoB - descuentoA;
        })[0];

        const porcentaje = parseFloat(promocionMayor.descuento || 0) * 100;
        const descuento = (producto.precio * producto.cantidad * parseFloat(promocionMayor.descuento || 0));

        if (descuento > 0) {
          promocionesAplicadas.push({
            idPromocion: promocionMayor.idPromocion,
            tipo: '1',
            nombre: promocionMayor.nombre,
            porcentajeDescuento: porcentaje,
            productos: [producto.idPedidoDetalle],
            descuento: descuento,
            descripcion: `${porcentaje}% en ${producto.nombre}`
          });
        }
      }
    });
  }

  /**
   * Aplicar promociones tipo 2 (2x1, 3x2, etc.)
   * Versión CORREGIDA que garantiza aplicar la promoción a productos idénticos
   * y siempre descuenta los productos más baratos
   * @param {Array} pedido - Productos en el pedido (incluye nuevos y guardados)
   * @param {Array} promocionesDisponibles - Promociones disponibles
   * @param {Array} promocionesAplicadas - Array donde se agregarán las promociones aplicadas
   */
  static aplicarPromocionesT2(pedido, promocionesDisponibles, promocionesAplicadas) {
    // Filtrar promociones tipo 2 activas
    const promocionesT2 = promocionesDisponibles.filter(p =>
      (p.tipo === '2' || p.tipo === 2) && p.activa !== false
    );

    console.log('🔥 Promociones T2 disponibles:', promocionesT2);
    console.log('🔥 Pedido para promociones T2:', pedido);

    if (promocionesT2.length === 0) return;

    // Para cada promoción tipo 2
    promocionesT2.forEach(promocion => {
      console.log('🔥 Procesando promoción:', promocion);
      
      // Paso 1: Obtener todos los productos aplicables a esta promoción
      let productosAplicables = pedido.filter(producto => {
        const idProducto = parseInt(producto.idProducto || producto.idPlatillo);
        const aplicable = promocion.aplicaProductos && promocion.aplicaProductos.includes(idProducto);
        console.log(`🔥 Producto ${producto.nombre} (ID: ${idProducto}) - Aplicable: ${aplicable}`);
        return aplicable;
      });

      console.log('🔥 Productos aplicables encontrados:', productosAplicables);

      // Si no hay productos suficientes, saltar esta promoción
      if (productosAplicables.length < 1) {
        console.log('🔥 No hay productos aplicables, saltando promoción');
        return;
      }

      // Agrupar productos por tipo para facilitar la aplicación de la promoción
      // para productos idénticos
      const productosAgrupados = {};

      productosAplicables.forEach(producto => {
        // Crear una clave única para identificar productos del mismo tipo
        const productoKey = `${producto.idProducto || producto.idPlatillo}_${producto.precio}`;

        if (!productosAgrupados[productoKey]) {
          productosAgrupados[productoKey] = [];
        }

        // Agregar a la lista de productos de este tipo
        productosAgrupados[productoKey].push(producto);
      });

      // Expandir todos los productos por su cantidad
      let todosLosProductosExpandidos = [];

      Object.keys(productosAgrupados).forEach(key => {
        const grupoProductos = productosAgrupados[key];

        grupoProductos.forEach(producto => {
          for (let i = 0; i < producto.cantidad; i++) {
            todosLosProductosExpandidos.push({
              idPedidoDetalle: producto.idPedidoDetalle,
              idProducto: parseInt(producto.idProducto || producto.idPlatillo),
              nombre: producto.nombre,
              precio: parseFloat(producto.precio),
              status: producto.status,
              unidadIndex: i,
              esGuardado: producto.status === 'guardado',
              productoKey: key  // Usamos la clave para agrupar productos idénticos
            });
          }
        });
      });


      // Si no hay suficientes productos expandidos, salir
      if (todosLosProductosExpandidos.length < 2) return;

      // Ordenar productos POR PRECIO DE MAYOR A MENOR para cobrar siempre los más caros
      // y aplicar descuento/gratis a los más baratos
      todosLosProductosExpandidos.sort((a, b) => {
        if (a.precio === b.precio) {
          // Si los precios son iguales, ordenar por otros criterios como status o ID
          return a.esGuardado ? -1 : 1; // Productos guardados primero (para cobrarlos)
        }
        return b.precio - a.precio; // Mayor precio primero
      });

      // Configurar parámetros de la promoción
      const cantidadCompra = parseInt(promocion.cantidad1) || 1;
      const cantidadGratis = parseInt(promocion.cantidad2) || 1;
      const porcentajeDescuento = parseFloat(promocion.descuento || 1);
      const grupoSize = cantidadCompra + cantidadGratis;

      // Calcular cuántos conjuntos completos podemos formar
      const totalConjuntos = Math.floor(todosLosProductosExpandidos.length / grupoSize);

      console.log('🔥 Configuración promoción:', { cantidadCompra, cantidadGratis, grupoSize, totalProductos: todosLosProductosExpandidos.length, totalConjuntos });

      if (totalConjuntos === 0) {
        console.log('🔥 No se pueden formar conjuntos completos, saltando promoción');
        return;
      }

      // Inicializar variables para tracking
      let descuentoTotal = 0;
      const productosIncluidos = new Map(); // Mapa: idPedidoDetalle -> cantidad incluida
      const productosConDescuento = new Map(); // Mapa: idPedidoDetalle -> cantidad con descuento

      // Conjunto para rastrear productos ya procesados
      const productosYaProcesados = new Set();

      // NUEVA LÓGICA OPTIMIZADA: Separación global de productos para máxima optimización
      // En lugar de formar grupos secuenciales, separamos globalmente los más caros y más baratos
      
      const totalProductosParaCobrar = cantidadCompra * totalConjuntos;
      const totalProductosParaDescuento = cantidadGratis * totalConjuntos;
      
      console.log(`🔥 Distribución global: ${totalProductosParaCobrar} productos a cobrar, ${totalProductosParaDescuento} productos con descuento`);
      
      // Separar globalmente: los MÁS CAROS se cobran, los MÁS BARATOS se regalan
      const productosParaCobrar = todosLosProductosExpandidos.slice(0, totalProductosParaCobrar);
      const productosParaDescuento = todosLosProductosExpandidos.slice(-totalProductosParaDescuento);
      
      console.log(`🔥 Productos para cobrar (${productosParaCobrar.length} más caros):`, 
        productosParaCobrar.map(p => `${p.nombre} $${p.precio}`));
      console.log(`🔥 Productos para descuento (${productosParaDescuento.length} más baratos):`, 
        productosParaDescuento.map(p => `${p.nombre} $${p.precio}`));

      // Procesar productos a cobrar (precio normal)
      productosParaCobrar.forEach(producto => {
        const productoKey = `${producto.idPedidoDetalle}_${producto.unidadIndex}`;
        
        if (productosYaProcesados.has(productoKey)) return;
        productosYaProcesados.add(productoKey);

        // Registrar que este producto se cobra normal
        if (!productosIncluidos.has(producto.idPedidoDetalle)) {
          productosIncluidos.set(producto.idPedidoDetalle, 0);
        }
        productosIncluidos.set(
          producto.idPedidoDetalle,
          productosIncluidos.get(producto.idPedidoDetalle) + 1
        );
      });

      // Procesar productos con descuento
      productosParaDescuento.forEach(producto => {
        const productoKey = `${producto.idPedidoDetalle}_${producto.unidadIndex}`;
        
        if (productosYaProcesados.has(productoKey)) return;
        productosYaProcesados.add(productoKey);

        // Registrar que este producto tiene descuento
        if (!productosConDescuento.has(producto.idPedidoDetalle)) {
          productosConDescuento.set(producto.idPedidoDetalle, 0);
        }
        productosConDescuento.set(
          producto.idPedidoDetalle,
          productosConDescuento.get(producto.idPedidoDetalle) + 1
        );

        // Calcular el descuento
        const descuentoProducto = producto.precio * porcentajeDescuento;
        descuentoTotal += descuentoProducto;
      });

      // Si hay descuento, registrar la promoción aplicada
      if (descuentoTotal > 0) {
        console.log('🔥 Creando promoción aplicada con descuento:', descuentoTotal);
        
        // Convertir los mapas a arrays para guardar en la promoción
        const productosIncluidosInfo = [];
        const productosConDescuentoInfo = [];

        // Procesar productos incluidos (precio normal)
        for (const [idPedidoDetalle, cantidad] of productosIncluidos.entries()) {
          productosIncluidosInfo.push({
            idPedidoDetalle,
            cantidad
          });
        }

        // Procesar productos con descuento
        for (const [idPedidoDetalle, cantidad] of productosConDescuento.entries()) {
          productosConDescuentoInfo.push({
            idPedidoDetalle,
            cantidad
          });
        }

        const promocionAplicada = {
          idPromocion: promocion.idPromocion,
          tipo: '2',
          nombre: promocion.nombre,
          cantidadCompra,
          cantidadGratis,
          porcentajeDescuento: porcentajeDescuento * 100,
          productosIncluidos: Array.from(productosIncluidos.keys()), // IDs de productos normales
          productosGratis: Array.from(productosConDescuento.keys()), // IDs de productos con descuento
          productosIncluidosDetalle: productosIncluidosInfo, // Con cantidad
          productosGratisDetalle: productosConDescuentoInfo, // Con cantidad
          descuento: descuentoTotal,
          conjuntosCompletos: totalConjuntos,
          descripcion: promocion.descripcion ||
            `Compra ${cantidadCompra}, lleva ${cantidadGratis} con ${porcentajeDescuento * 100}% descuento`
        };

        console.log('🔥 Promoción aplicada creada:', promocionAplicada);
        promocionesAplicadas.push(promocionAplicada);
      } else {
        console.log('🔥 No se aplicó promoción - descuento total es 0');
      }
    });
  }
  /**
 * Aplicar promociones tipo 3 (combos especiales)
 * Versión CORREGIDA que garantiza una relación 1:1 entre productos a cobrar y regalar
 * @param {Array} pedido - Productos en el pedido
 * @param {Array} promocionesDisponibles - Promociones disponibles
 * @param {Array} promocionesAplicadas - Array donde se agregarán las promociones aplicadas
 */
  static async aplicarPromocionesT3(pedido, promocionesDisponibles, promocionesAplicadas) {
    // Filtrar promociones tipo 3 activas
    const promocionesT3 = promocionesDisponibles.filter(p =>
      (p.tipo === '3' || p.tipo === 3) && p.activa !== false
    );

    console.log('🎯 Promociones T3 disponibles:', promocionesT3);
    console.log('🎯 Pedido para promociones T3:', pedido);

    if (promocionesT3.length === 0) {
      console.log('🎯 No hay promociones tipo 3 disponibles');
      return;
    }

    // Para cada promoción tipo 3, obtener sus detalles
    for (const promocion of promocionesT3) {
      try {
        console.log('🎯 Procesando promoción T3:', promocion);
        
        // Verificar si tenemos los detalles de la promoción
        if (!promocion.productosCobrar || !promocion.productosRegalar) {
          console.log('🎯 No hay detalles de productos, intentando obtener desde API');
          // Si no, intentar obtenerlos desde la API
          try {
            // Importar API de manera dinámica para evitar dependencias circulares
            const API = window.API || (await import('../utils/api')).default;
            const detallePromo = await API.promociones.getDetallePromocion(promocion.idPromocion);

            if (detallePromo) {
              promocion.productosCobrar = detallePromo.productosCobrar || [];
              promocion.productosRegalar = detallePromo.productosRegalar || [];
              // Asegurar que cantidad1/cantidad2 estén disponibles desde el detalle
              if (detallePromo.promocion) {
                promocion.cantidad1 = detallePromo.promocion.cantidad1 ?? promocion.cantidad1;
                promocion.cantidad2 = detallePromo.promocion.cantidad2 ?? promocion.cantidad2;
              }
              console.log('🎯 Detalles obtenidos de API:', { productosCobrar: promocion.productosCobrar, productosRegalar: promocion.productosRegalar, cantidad1: promocion.cantidad1, cantidad2: promocion.cantidad2 });
            }
          } catch (error) {
            console.error(`🎯 Error al obtener detalles de promoción ${promocion.idPromocion}:`, error);
            continue; // Pasar a la siguiente promoción
          }
        }

        // Verificar si tenemos los detalles necesarios para procesar
        if (!promocion.productosCobrar || !promocion.productosRegalar ||
          promocion.productosCobrar.length === 0 || promocion.productosRegalar.length === 0) {
          console.log('🎯 No hay detalles suficientes para procesar promoción, saltando');
          continue; // No podemos procesar sin estos datos
        }

        console.log('🎯 Productos a cobrar:', promocion.productosCobrar);
        console.log('🎯 Productos a regalar:', promocion.productosRegalar);

        // Expandir productos por cantidad para una relación 1:1 precisa
        let productosCobrarExpandidos = [];
        let productosRegalarExpandidos = [];

        // Obtener productos a cobrar y expandirlos por cantidad
        pedido.forEach(producto => {
          const idProducto = parseInt(producto.idProducto || producto.idPlatillo);

          // Si el producto es de los que se cobran
          if (promocion.productosCobrar.includes(idProducto)) {
            console.log(`🎯 Producto a cobrar encontrado: ${producto.nombre} (${producto.cantidad} unidades)`);
            // Expandir por cada unidad
            for (let i = 0; i < producto.cantidad; i++) {
              productosCobrarExpandidos.push({
                idPedidoDetalle: producto.idPedidoDetalle,
                idProducto: idProducto,
                precio: producto.precio,
                nombre: producto.nombre,
                unidadIndex: i
              });
            }
          }

          // Si el producto es de los que se regalan
          if (promocion.productosRegalar.includes(idProducto)) {
            console.log(`🎯 Producto a regalar encontrado: ${producto.nombre} (${producto.cantidad} unidades)`);
            // Expandir por cada unidad
            for (let i = 0; i < producto.cantidad; i++) {
              productosRegalarExpandidos.push({
                idPedidoDetalle: producto.idPedidoDetalle,
                idProducto: idProducto,
                precio: producto.precio,
                nombre: producto.nombre,
                unidadIndex: i
              });
            }
          }
        });

        console.log('🎯 Productos a cobrar expandidos:', productosCobrarExpandidos);
        console.log('🎯 Productos a regalar expandidos:', productosRegalarExpandidos);

        // Si no hay productos suficientes para aplicar la promoción
        if (productosCobrarExpandidos.length === 0 || productosRegalarExpandidos.length === 0) {
          console.log('🎯 No hay productos suficientes para aplicar promoción T3');
          continue;
        }

        // Ordenar productos a regalar por precio (de menor a mayor)
        // Esto asegura que se aplique el descuento a los productos más baratos
        productosRegalarExpandidos.sort((a, b) => a.precio - b.precio);

        // También ordenar productos a cobrar por precio (de mayor a menor)
        // Para cobrar siempre los más caros
        productosCobrarExpandidos.sort((a, b) => b.precio - a.precio);

        // Usar cantidad1 y cantidad2 para definir la proporción del combo
        // cantidad1 = cuántos productos debe comprar el cliente (mínimo)
        // cantidad2 = máximo de productos que se regalan por cada cantidad1 comprados
        const cantidadCobrar = parseInt(promocion.cantidad1) || 1;
        const maxRegalar = parseInt(promocion.cantidad2) || 1;

        // Calcular cuántos conjuntos podemos formar según los productos a cobrar
        const numConjuntos = Math.floor(productosCobrarExpandidos.length / cantidadCobrar);

        // Calcular cuántos productos se pueden regalar en total (limitado por maxRegalar por conjunto y disponibles)
        const totalMaxRegalar = numConjuntos * maxRegalar;
        const totalRegalar = Math.min(totalMaxRegalar, productosRegalarExpandidos.length);

        console.log('🎯 Configuración T3:', { cantidadCobrar, maxRegalar, numConjuntos, totalMaxRegalar, totalRegalar });

        if (numConjuntos >= 1 && totalRegalar >= 1) {
          // Preparar para seguimiento de productos con descuento
          let descuentoTotal = 0;
          const productosGratisIds = new Set();
          const productosIncluidosIds = new Set();
          const productosGratisConteo = new Map();
          const productosIncluidosConteo = new Map();

          console.log('🎯 Productos a cobrar ordenados (caros primero):', productosCobrarExpandidos);
          console.log('🎯 Productos a regalar ordenados (baratos primero):', productosRegalarExpandidos);

          // Procesar productos a cobrar (los necesarios para los conjuntos)
          const totalCobrar = numConjuntos * cantidadCobrar;
          for (let c = 0; c < totalCobrar; c++) {
            const productoCobrar = productosCobrarExpandidos[c];

            console.log(`🎯 Cobrar [${c + 1}/${totalCobrar}]: ${productoCobrar.nombre} ($${productoCobrar.precio})`);

            productosIncluidosIds.add(productoCobrar.idPedidoDetalle);
            if (!productosIncluidosConteo.has(productoCobrar.idPedidoDetalle)) {
              productosIncluidosConteo.set(productoCobrar.idPedidoDetalle, 0);
            }
            productosIncluidosConteo.set(
              productoCobrar.idPedidoDetalle,
              productosIncluidosConteo.get(productoCobrar.idPedidoDetalle) + 1
            );
          }

          // Procesar productos a regalar (hasta el máximo permitido)
          for (let r = 0; r < totalRegalar; r++) {
            const productoRegalar = productosRegalarExpandidos[r];

            console.log(`🎯 Regalar [${r + 1}/${totalRegalar}]: ${productoRegalar.nombre} ($${productoRegalar.precio})`);

            productosGratisIds.add(productoRegalar.idPedidoDetalle);
            if (!productosGratisConteo.has(productoRegalar.idPedidoDetalle)) {
              productosGratisConteo.set(productoRegalar.idPedidoDetalle, 0);
            }
            productosGratisConteo.set(
              productoRegalar.idPedidoDetalle,
              productosGratisConteo.get(productoRegalar.idPedidoDetalle) + 1
            );

            descuentoTotal += productoRegalar.precio;
          }

          console.log('🎯 Descuento total calculado:', descuentoTotal);

          // Si hay descuento, agregar la promoción
          if (descuentoTotal > 0) {
            console.log('🎯 Creando promoción T3 aplicada con descuento:', descuentoTotal);

            // Preparar información detallada de productos
            const productosGratisDetalle = [];
            const productosIncluidosDetalle = [];

            for (const [idPedidoDetalle, cantidad] of productosGratisConteo.entries()) {
              productosGratisDetalle.push({ idPedidoDetalle, cantidad });
            }

            for (const [idPedidoDetalle, cantidad] of productosIncluidosConteo.entries()) {
              productosIncluidosDetalle.push({ idPedidoDetalle, cantidad });
            }

            const promocionAplicada = {
              idPromocion: promocion.idPromocion,
              tipo: '3',
              nombre: promocion.nombre,
              productosIncluidos: Array.from(productosIncluidosIds),
              productosGratis: Array.from(productosGratisIds),
              productosIncluidosDetalle: productosIncluidosDetalle,
              productosGratisDetalle: productosGratisDetalle,
              descuento: descuentoTotal,
              conjuntosCompletos: numConjuntos,
              totalRegalados: totalRegalar,
              descripcion: promocion.descripcion || `Combo: compra ${cantidadCobrar}, gratis ${totalRegalar} de máx ${totalMaxRegalar}`
            };

            console.log('🎯 Promoción T3 aplicada creada:', promocionAplicada);
            promocionesAplicadas.push(promocionAplicada);
          } else {
            console.log('🎯 No se aplicó promoción T3 - descuento total es 0');
          }
        }
      } catch (error) {
        console.error(`Error al procesar promoción tipo 3 (${promocion.idPromocion}):`, error);
      }
    }
  }

  /**
   * Verificar si un producto tiene promociones aplicables
   * @param {Object} producto - Producto a verificar
   * @param {Array} promocionesDisponibles - Promociones disponibles
   * @returns {Object} - Información sobre promociones aplicables
   */
  static verificarPromocionesProducto(producto, promocionesDisponibles) {
    if (!producto || !promocionesDisponibles || promocionesDisponibles.length === 0) {
      return { enPromocion: false, promociones: [] };
    }

    const idProducto = parseInt(producto.idProducto || producto.idPlatillo);
    const promocionesAplicables = [];

    // Buscar promociones tipo 1 (descuento porcentual)
    const promocionesT1 = promocionesDisponibles.filter(p =>
      (p.tipo === '1' || p.tipo === 1) &&
      p.activa !== false &&
      p.aplicaProductos && p.aplicaProductos.includes(idProducto)
    );

    promocionesT1.forEach(promo => {
      promocionesAplicables.push({
        idPromocion: promo.idPromocion,
        nombre: promo.nombre,
        tipo: '1',
        porcentajeDescuento: parseFloat(promo.descuento || 0) * 100
      });
    });

    // Buscar promociones tipo 2 (2x1, etc.)
    const promocionesT2 = promocionesDisponibles.filter(p =>
      (p.tipo === '2' || p.tipo === 2) &&
      p.activa !== false &&
      p.aplicaProductos && p.aplicaProductos.includes(idProducto)
    );

    promocionesT2.forEach(promo => {
      promocionesAplicables.push({
        idPromocion: promo.idPromocion,
        nombre: promo.nombre,
        tipo: '2',
        cantidadCompra: parseInt(promo.cantidad1) || 1,
        cantidadGratis: parseInt(promo.cantidad2) || 1
      });
    });

    // Buscar promociones tipo 3 (combos especiales)
    const promocionesT3 = promocionesDisponibles.filter(p =>
      (p.tipo === '3' || p.tipo === 3) &&
      p.activa !== false
    );

    for (const promo of promocionesT3) {
      // Verificar si tenemos la información necesaria
      if ((promo.productosCobrar && promo.productosCobrar.includes(idProducto)) ||
        (promo.productosRegalar && promo.productosRegalar.includes(idProducto))) {
        promocionesAplicables.push({
          idPromocion: promo.idPromocion,
          nombre: promo.nombre,
          tipo: '3',
          productosCobrar: promo.productosCobrar || [],
          productosRegalar: promo.productosRegalar || []
        });
      }
    }

    return {
      enPromocion: promocionesAplicables.length > 0,
      promociones: promocionesAplicables
    };
  }

  /**
   * Verificar si un producto tiene promoción aplicada
   * @param {string} idPedidoDetalle - ID del detalle de pedido
   * @param {Array} promocionesAplicadas - Promociones aplicadas
   * @returns {boolean} - True si tiene promoción aplicada
   */
  static productoTienePromocion(idPedidoDetalle, promocionesAplicadas) {
    if (!idPedidoDetalle || !promocionesAplicadas || promocionesAplicadas.length === 0) {
      return false;
    }

    // Verificar si el producto está en alguna promoción
    for (const promo of promocionesAplicadas) {
      // Productos incluidos en la promoción
      if (promo.productosIncluidos && promo.productosIncluidos.includes(idPedidoDetalle)) {
        return true;
      }

      // Productos con descuento/gratis
      if (promo.productosGratis && promo.productosGratis.includes(idPedidoDetalle)) {
        return true;
      }

      // Productos en promociones tipo 1
      if (promo.productos && promo.productos.includes(idPedidoDetalle)) {
        return true;
      }
    }

    return false;
  }

  /**
   * Obtener información de promoción para un producto
   * @param {string} idPedidoDetalle - ID del detalle de pedido
   * @param {Array} promocionesAplicadas - Promociones aplicadas
   * @returns {Object} - Información de la promoción
   */
  static getInfoPromocionProducto(idPedidoDetalle, promocionesAplicadas) {
    if (!idPedidoDetalle || !promocionesAplicadas || promocionesAplicadas.length === 0) {
      return { tienePromocion: false };
    }

    for (const promo of promocionesAplicadas) {
      // Verificar promociones tipo 2 con información detallada de cantidades
      if (promo.tipo === '2' && promo.productosGratisDetalle && promo.productosIncluidosDetalle) {
        // Verificar si es producto con descuento (en productosGratisDetalle)
        const detalleDescuento = promo.productosGratisDetalle.find(d => d.idPedidoDetalle === idPedidoDetalle);
        if (detalleDescuento) {
          return {
            tienePromocion: true,
            tipo: promo.tipo,
            esGratis: true,
            cantidad: detalleDescuento.cantidad,
            promocion: promo
          };
        }

        // Verificar si es producto a precio regular (en productosIncluidosDetalle)
        const detallePrecioRegular = promo.productosIncluidosDetalle.find(d => d.idPedidoDetalle === idPedidoDetalle);
        if (detallePrecioRegular) {
          return {
            tienePromocion: true,
            tipo: promo.tipo,
            esGratis: false,
            cantidad: detallePrecioRegular.cantidad,
            promocion: promo
          };
        }
      }

      // Verificar si es producto gratis en promoción 2x1 (formato anterior)
      if (promo.tipo === '2' && promo.productosGratis && promo.productosGratis.includes(idPedidoDetalle)) {
        return {
          tienePromocion: true,
          tipo: promo.tipo,
          esGratis: true,
          promocion: promo
        };
      }

      // Verificar si es producto incluido en promoción 2x1 (se cobra completo) (formato anterior)
      if (promo.tipo === '2' && promo.productosIncluidos && promo.productosIncluidos.includes(idPedidoDetalle)) {
        return {
          tienePromocion: true,
          tipo: promo.tipo,
          esGratis: false,
          promocion: promo
        };
      }

      // Verificar promociones tipo 1
      if (promo.tipo === '1' && promo.productos && promo.productos.includes(idPedidoDetalle)) {
        return {
          tienePromocion: true,
          tipo: promo.tipo,
          promocion: promo
        };
      }

      // Verificar promociones tipo 3
      if (promo.tipo === '3' &&
        ((promo.productosIncluidos && promo.productosIncluidos.includes(idPedidoDetalle)) ||
          (promo.productosGratis && promo.productosGratis.includes(idPedidoDetalle)))) {
        return {
          tienePromocion: true,
          tipo: promo.tipo,
          esGratis: promo.productosGratis && promo.productosGratis.includes(idPedidoDetalle),
          promocion: promo
        };
      }
    }

    return { tienePromocion: false };
  }

  /**
   * Calcular los totales del pedido
   * @param {Array} pedido - Array de productos en el pedido
   * @param {Array} promocionesAplicadas - Promociones aplicadas
   * @returns {Object} - Totales del pedido
   */
  static async calcularTotalesPedido(pedido, promocionesDisponibles) {
    if (!pedido || pedido.length === 0) {
      return { subtotal: 0, descuentos: 0, total: 0 };
    }

    // Primero calcular las promociones que se aplican al pedido actual
    const promocionesAplicadas = await this.calcularPromociones(pedido, promocionesDisponibles);

    // Calcular subtotal sin promociones
    const subtotal = pedido.reduce((total, item) => {
      return total + (item.precio * item.cantidad);
    }, 0);

    // Calcular descuentos
    let descuentos = 0;
    if (promocionesAplicadas && promocionesAplicadas.length > 0) {
      descuentos = promocionesAplicadas.reduce((total, promocion) => {
        return total + (promocion.descuento || 0);
      }, 0);
    }

    // Calcular total
    const total = subtotal - descuentos;

    return {
      subtotal,
      descuentos,
      total,
      promocionesAplicadas
    };
  }
}

// Exportar al objeto window para pruebas en desarrollo
if (typeof window !== 'undefined') {
  window.PromocionesService = PromocionesService;
}

export default PromocionesService;